import { Actor, Animation, SpriteSheet, Vector } from "excalibur";
import { Resources } from "../Resources";
import { Config } from "../config";
import { getHiveSprite } from "../utils";

export class OpenHive extends Actor {
  constructor(x, y, hiveStats) {
    super({ x, y });
    this.flyingActor = new Actor({ pos: new Vector(0, 0), z: 10 });
    this.hiveStats = hiveStats;
  }
  onInitialize() {
    let height;
    console.log("hiveStats from openHive : ", this.hiveStats);
    const smallHiveSrites = SpriteSheet.fromImageSource({
      image: Resources.SmallHives,
      grid: {
        spriteWidth: 16,
        spriteHeight: 16,
        rows: 10,
        columns: 6,
      },
    });
    const bigHiveSrites = SpriteSheet.fromImageSource({
      image: Resources.BigHives,
      grid: {
        spriteWidth: 16,
        spriteHeight: 32,
        rows: 10,
        columns: 6,
      },
    });
    const oneOpen = smallHiveSrites.getSprite(0, 0);
    const oneOneOpen = smallHiveSrites.getSprite(2, 0);
    const twoOpen = smallHiveSrites.getSprite(1, 0);
    const oneTwoOpen = bigHiveSrites.getSprite(2, 1);
    const twoOneOpen = bigHiveSrites.getSprite(3, 1);
    const twoTwoOpen = bigHiveSrites.getSprite(4, 1);
    const oneThreeOpen = bigHiveSrites.getSprite(5, 1);
    const twoThreeOpen = bigHiveSrites.getSprite(0, 2);
    const oneFourOpen = bigHiveSrites.getSprite(1, 2);
    const twoFourOpen = bigHiveSrites.getSprite(2, 2);
    const oneFiveOpen = bigHiveSrites.getSprite(3, 2);
    const one = smallHiveSrites.getSprite(0, 1);
    const oneOne = smallHiveSrites.getSprite(2, 1);

    const two = smallHiveSrites.getSprite(1, 1);

    const twoOne = bigHiveSrites.getSprite(1, 0);
    const oneTwo = bigHiveSrites.getSprite(0, 0);
    const twoTwo = bigHiveSrites.getSprite(2, 0);
    const oneThree = bigHiveSrites.getSprite(3, 0);
    const twoThree = bigHiveSrites.getSprite(4, 0);
    const oneFour = bigHiveSrites.getSprite(5, 0);
    const twoFour = bigHiveSrites.getSprite(0, 1);
    const oneFive = bigHiveSrites.getSprite(1, 1);
    this.graphics.add("oneOpen", oneOpen);
    this.graphics.add("oneOneOpen", oneOneOpen);
    this.graphics.add("oneTwoOpen", oneTwoOpen);
    this.graphics.add("oneThreeOpen", oneThreeOpen);
    this.graphics.add("oneFourOpen", oneFourOpen);
    this.graphics.add("oneFiveOpen", oneFiveOpen);
    this.graphics.add("twoOpen", twoOpen);
    this.graphics.add("twoOneOpen", twoOneOpen);
    this.graphics.add("twoTwoOpen", twoTwoOpen);
    this.graphics.add("twoThreeOpen", twoThreeOpen);
    this.graphics.add("twoFourOpen", twoFourOpen);
    this.graphics.add("one", one);
    this.graphics.add("oneOne", oneOne);
    this.graphics.add("two", two);
    this.graphics.add("twoOne", twoOne);
    this.graphics.add("oneTwo", oneTwo);
    this.graphics.add("twoTwo", twoTwo);
    this.graphics.add("oneThree", oneThree);
    this.graphics.add("twoThree", twoThree);
    this.graphics.add("oneFour", oneFour);
    this.graphics.add("twoFour", twoFour);
    this.graphics.add("oneFive", oneFive);

    const beeSprite = SpriteSheet.fromImageSource({
      image: Resources.Bees,
      grid: {
        spriteWidth: 16,
        spriteHeight: 16,
        rows: 1,
        columns: 8,
      },
    });
    const flying = new Animation({
      frames: [
        { graphic: beeSprite.getSprite(0, 0), duration: 100 },
        { graphic: beeSprite.getSprite(1, 0), duration: 100 },
        { graphic: beeSprite.getSprite(2, 0), duration: 100 },
        { graphic: beeSprite.getSprite(3, 0), duration: 100 },
        { graphic: beeSprite.getSprite(4, 0), duration: 100 },
        { graphic: beeSprite.getSprite(5, 0), duration: 100 },
        { graphic: beeSprite.getSprite(6, 0), duration: 100 },
        { graphic: beeSprite.getSprite(7, 0), duration: 100 },
      ],
    });
    this.flyingActor.graphics.add("flying", flying);
    if (this.hiveStats.alive) {
      this.flyingActor.graphics.use("flying");
    }

    this.addChild(this.flyingActor);
    this.activeSprite = getHiveSprite(this.hiveStats);
  }
  onPreUpdate() {
    this.graphics.use(this.activeSprite);
  }
}
